import { render, staticRenderFns } from "./AccessPanel.vue?vue&type=template&id=344c65a8&scoped=true&"
import script from "./AccessPanel.vue?vue&type=script&lang=js&"
export * from "./AccessPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c65a8",
  null
  
)

export default component.exports